<script setup>

</script>

<template>
    <div class="w-full form-group form-wrapper">
        <hr/>
    </div>
</template>

<style scoped>

</style>
